import React, { useContext, useEffect, useRef, useState } from 'react';
import { Navbar, Nav, Form, InputGroup, FormControl, Accordion, OverlayTrigger, Tooltip, Badge, NavItem, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faEllipsisVertical, faHamburger, faSquare } from '@fortawesome/free-solid-svg-icons';
import Logo from '../../Assets/logo.svg';
import Logoblue from '../../Assets/logo-blue.png';
import Logoshort from '../../Assets/logo_icon.svg';
import Logoshortblue from '../../Assets/logoshort.png';
import Lessthan from '../../Assets/lessthan_icon.png';
import userDefault from '../../Assets/images/user.png';
import { ExploreContext } from '../../Context/ExploreContext';
import { UserContext } from '../../Context/UserContext';
import { App, SidebarApps, SidebarDataItem, SidebarItemProps, SidebarProps, User } from '../../interface';
import UserProfileModal from '../UserProfileModal/UserProfileModal';
import { useOktaAuth } from '@okta/okta-react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import ContactModal from '../ContactModal/ContactModal';
import Intercom, { hide, show, showMessages, update } from "@intercom/messenger-js-sdk";

import files from "../../Assets/icons/folder-lock.png"
import news from "../../Assets/icons/newspaper.png"
import bot from "../../Assets/icons/bot-message-square.png"
import help from "../../Assets/icons/circle-help.png"
import MenuButton from '../MenuButton';


type MenuRef = HTMLDivElement | null;
interface HeaderProps {
  collapsed: boolean;
  toggleSidebar: () => void;
}
const CustomHeader: React.FC<HeaderProps> = ({ toggleSidebar, collapsed }) => {
  const location = useLocation();
  const menuRef = useRef<MenuRef>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const { authState, oktaAuth } = useOktaAuth();
  const logout = async () => {
    sessionStorage.removeItem('chatOpened');
    oktaAuth.signOut()
  };
  const { getUserData, getUserDataViewas ,getPermissions} = useContext(UserContext);
  const { getAppsByUser, getSidebar } = useContext(ExploreContext);
  const [showModal, setShowModal] = useState(false);
  const handleModal = () => setShowModal(!showModal);
  const [showModalContact, setShowModalContact] = useState(false);
  const handleModalContact = () => setShowModalContact(!showModalContact);
  const [showModalProfile, setShowModalProfile] = useState(false);
  const handleModalProfile = () => setShowModalProfile(!showModalProfile);
  const [dataDemo, setDataDemo] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sidebarDataMenu, setSidebarDataMenu] = useState<SidebarDataItem[]>([]);
  const [userData, setUserData] = useState<User>();
  const [sidebarData, setSidebarData] = useState<SidebarDataItem[]>([]);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const handleMenuProfile = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowProfileMenu((prev) => !prev);
  };
  const renderTooltip = (props: any, name: string) => (
    <Tooltip id="button-tooltip" {...props}>
      {name}
    </Tooltip>
  );

  const getData = async () => {

    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    let user = await getUserData(okta_id)
    const userView = localStorage.getItem("userView")!;
    let apps;
    let sidebar;
    if (userView != null) {
      let userViewAs = await getUserDataViewas(userView)
      apps = await getAppsByUser(userViewAs.id, user.id);
      sidebar = await getSidebar(userViewAs.id)
    } else {
      apps = await getAppsByUser(user.id);
      sidebar = await getSidebar(user.id)
    }
    setSidebarData(sidebar)
    if (apps instanceof Error) {
      console.error("Error fetching apps", apps);
    } else {

      // setSidebarDataMenu(updatedSidebarData)
    }
  };
  const getDataUser = async () => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    const user = await getUserData(okta_id)
    trackUserWithGtag(user.id)
    setUserData(user)
    localStorage.setItem("name", user.user_firstname);
    localStorage.setItem("email", user.user_email);
    localStorage.setItem("hubspotID", user.account.huspot_id);
  };
  const trackUserWithGtag = (userId: string) => {
    (window as any).gtag?.("config", "G-R38JR2D8KC", { user_id: userId });
  };


  useEffect(() => {
    getDataUser()
    getData()
    getPermissions(); 
    document.title = "Gray DI - Hub";
  }, []);


  useEffect(() => {
    Intercom({
      app_id: `${process.env.REACT_APP_INTERCOM_APP_ID}`,
      email: userData?.user_email,
      user_hash: userData?.user_hash,
    });
    if (location.pathname === '/home') {

      const hasOpenedChat = sessionStorage.getItem('chatOpened');

      if (!hasOpenedChat) {

        show();

        sessionStorage.setItem('chatOpened', 'true');
      }

    } else {
      hide();
    }
  }, [location.pathname, userData])

  const handleCustomButtonClick = () => {
    // Actualizar los datos del usuario
    // update({
    //   name: userData?.user_firstname,
    //   email: userData?.user_email,

    // });

    // Mostrar el chat
    showMessages();
  };
  const handleShowHelp = () => {
    // Actualizar los datos del usuario
    // update({
    //   name: userData?.user_firstname,
    //   email: userData?.user_email,

    // });

    // Mostrar el chat
    show();
  };
  // Función para cerrar el menú cuando se hace clic fuera de él
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as Node;
    if (
      menuRef.current && !menuRef.current.contains(target) &&
      buttonRef.current && !buttonRef.current.contains(target)
    ) {
      setShowProfileMenu(false);
    }
  };
  useEffect(() => {
    if (showProfileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfileMenu]);

  return (
    <Row className='position-sticky top-0 z-3' >
      <Navbar bg="light" expand="lg" className="d-flex justify-content-between flex-sm-row  p-0 header">
        <div className='d-flex justify-content-between align-items-center flex-sm-row '>
          <div className='d-md-none d-block'>
            <MenuButton
              isActive={collapsed}
              onClick={toggleSidebar}
              size={30}
            />
          </div>

          <a href="/" className='py-2 px-md-4 p-sm-0'>
            <img src={Logoblue} alt="Logo gray" className='header-logo img-fluid' />
            {/* <img src={Logoshortblue} alt="Logo gray" className='header-logo img-fluid d-sm-none d-block' /> */}

          </a>
        </div>
        <div className='d-flex justify-content-end  p-0 '>
          {/* Left icons */}
          <Nav className=" d-flex align-items-center flex-row">
            {userData?.hasAccess && <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props) => renderTooltip(props, 'Secure File Share')}
            >
              <Nav.Link href="https://files.graydi.us/" target="_blank" className="d-flex align-items-center mx-1">
                <img src={files} alt="" width={20} />
              </Nav.Link>
            </OverlayTrigger>}

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props) => renderTooltip(props, 'Customer Success Hub')}
            >

              <Nav.Link href="https://www.graydi.us/customer-success-hub" target="_blank" className='mx-1'>
                <img src={news} alt="" width={20} />
              </Nav.Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props) => renderTooltip(props, 'Ask a Question')}
            >

              <Nav.Link className='mx-1' id='my_custom_link' onClick={handleCustomButtonClick}>
                <img src={bot} alt="" width={20} />
              </Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props) => renderTooltip(props, 'Get Help')}
            >

              <Nav.Link target="_blank" className='mx-1' id='my_custom_link' onClick={handleShowHelp}>
                <img src={help} alt="" width={20} />
              </Nav.Link>
            </OverlayTrigger>
          </Nav>


          <div className="profile d-flex align-items-center justify-content-center   bg-9">
            <div className="profile_content d-flex align-items-center justify-content-sm-center justify-content-md-between py-1">
              <div ref={buttonRef} className="d-flex justify-content-between cursor-pointer" onClick={handleMenuProfile}>
                <div className="profile_avatar">
                  <img src={userDefault} alt="Avatar" className="transition-all" />
                </div>
                <div className="d-sm-flex justify-content-center align-items-center d-none me-3">
                  <strong className="profile_name">{userData?.user_firstname}</strong>
                </div>
              </div>
              {/* 
            <div className='text-center px-1  cursor-pointer' onClick={handleMenuProfile}>
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </div> */}

              {/* Menú desplegable con animación */}
              <div ref={menuRef} className={`profile-tooltip z-3 position-absolute ${showProfileMenu ? 'active' : ''}`}>
                <ul className="list-group p-2 rounded-0">
                  <li
                    className="cursor-pointer pb-1 hover-bold"
                    onClick={() => {
                      setShowProfileMenu(false);
                      handleModalProfile();
                    }}
                  >
                    View Profile
                  </li>

                  {(userData?.role.id == 1 || userData?.account_id == 1) && (
                    <Accordion>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          <span>Administration</span>
                        </Accordion.Header>
                        <Accordion.Body className="pt-0">
                          <Nav className="flex-column hover-bold">
                            {(userData?.role.id == 1 || userData?.account_id == 1) && (
                              <Nav.Item className="hover-bold">
                                <Nav.Link href="/admin#users">Users</Nav.Link>
                              </Nav.Item>
                            )}
                            {userData?.role.id === 1 && (
                              <>
                                <Nav.Item className="hover-bold">
                                  <Nav.Link href="/admin#applications">Application</Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="hover-bold">
                                  <Nav.Link href="/admin#environment">Environment</Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="hover-bold">
                                  <Nav.Link href="/admin#ai-agent">AI Agent</Nav.Link>
                                </Nav.Item>
                              </>
                            )}
                            
                          </Nav>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  )}

                  <li className="cursor-pointer pb-1 hover-bold" onClick={logout}>Log Out</li>
                </ul>
              </div>
            </div>
          </div>


        </div>
      </Navbar>
      <ContactModal showModal={showModalContact} handleModal={handleModalContact} />
      <UserProfileModal showModal={showModalProfile} handleModal={handleModalProfile} userProfile={userData} handleModalContact={handleModalContact} />


    </Row>
  );
};

export default CustomHeader;
